














































































import { Component, Watch } from 'vue-property-decorator'
import api from "../../api/index"
import Lists from '../components/Lists.vue'
import CondominiumListMap from "../components/CondominiumListMap.vue"

@Component({
  components: {
    CondominiumListMap
  }
})
export default class CondominiumList extends Lists {
  isLoading = true
  dataType = 'admins'
  dataTypeLabel = 'administrateur'
  condominiums:any[] = []

  selectedCondominiumId:any = 0

  wordSearched = ""

  mapViewIsActive = false
  listViewIsActive = true

  selectCondominium(id:any) {
    this.selectedCondominiumId = id
  }

  get totalRows() {
    return this.condominiums.length < this.perPage ? this.condominiums.length : this.perPage
  }

  goToMapView() {
    this.mapViewIsActive = true
    this.listViewIsActive = false
  }
  goToListView() {
    this.mapViewIsActive = false
    this.listViewIsActive = true
  }

  goToCondominium(row:any) {
    const condominiumId = row.id
    this.$router.push({ name: 'condominiumProfile', params: { condominiumId }})
  }

  async mounted() {
    await api.setToken()
    this.isLoading = true
    await this.getAllCondominiums()
    this.isLoading = false
    if (this.$route.query.id) {
      this.selectedCondominiumId = this.$route.query.id
      this.goToMapView()
    } else {
      this.selectedCondominiumId = this.condominiums[0].id
    }
  }

  @Watch('perPage')
  @Watch('wordSearched')
  @Watch('currentPage')
  onSearchPropsChanged(val: any, old: any) {
    if ((old && val && val.toString() === old.toString()) || this.isLoading) {
      return
    }
    this.getAllCondominiums()
  }

  async fetchData() {
    this.getAllCondominiums()
  }
  async getAllCondominiums() {
    try {
      const res = await api.get("bo/condominiums", { params: {
        page: this.currentPage,
        per_page: this.perPage,
        keywords: this.wordSearched,
        order: this.sortField,
        order_desc: this.sortOrder,
      }})
      this.totalPages = parseInt(res.headers["x-pagination-total-pages"])
      this.totalResults = parseInt(res.headers["x-pagination-total"])
      this.perPage = parseInt(res.headers["x-pagination-per-page"])

      this.condominiums = res.data
    } catch (e) {
      if (e.response.status === 401) {
        console.log(e.response.status)
      }
    }
  }

}
